export const TrustBanner = () => {
	return (
		<section className="py-6 bg-surface-50 border-y border-surface-100">
			<div className="container-main">
				<div className="flex flex-col md:flex-row items-center justify-between gap-6">
					{/* Trust text */}
					<div className="flex items-center gap-3">
						<div className="w-10 h-10 bg-accent/10 rounded-full flex items-center justify-center">
							<svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
							</svg>
						</div>
						<p className="text-body-md text-surface-600">
							<span className="font-semibold text-primary">Más de 50,000 guatemaltecos</span> confían en nosotros
						</p>
					</div>

					{/* Trust badges */}
					<div className="flex items-center gap-6 md:gap-8">
						<div className="flex items-center gap-2">
							<svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
							</svg>
							<span className="text-body-sm font-medium text-surface-700">Datos seguros</span>
						</div>
						<div className="w-px h-6 bg-surface-200 hidden md:block" />
						<div className="flex items-center gap-2">
							<svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
							</svg>
							<span className="text-body-sm font-medium text-surface-700">Licenciado</span>
						</div>
						<div className="w-px h-6 bg-surface-200 hidden md:block" />
						<div className="flex items-center gap-2">
							<svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
							</svg>
							<span className="text-body-sm font-medium text-surface-700">Proceso rápido</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
